import { useIntl } from "react-intl";
import React, { RefObject, useState, FunctionComponent, useRef, Component } from "react";
import GoogleMapReact from "google-map-react";
import { useStaticQuery, graphql, navigate } from "gatsby";
import { Row, Col, Hidden, Visible } from "react-grid-system";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

import Checkbox from "../common/Checkbox";
import { FORMSPREE_ADDRESS } from "./../../config";

import {
  Container,
  Wrapper,
  Contact,
  ContactInfo,
  ContactForm,
  ContactSupport,
  ContactAddress
} from "./styles";

interface IProps {
  white?: boolean;
  reference?: RefObject<HTMLDivElement>;
}

const Marker = ({ className, ...rest }: any) => (
  <div className={className} {...rest} />
);

const ContactSection: FunctionComponent<IProps> = props => {
  const { formatMessage } = useIntl();
  const recaptchaRef = useRef();
  const [agreePolicies, setAgreePolicies] = useState<boolean>(false);
  const [agreeNewsletter, setAgreeNewsletter] = useState<boolean>(false);
  const [captchaValue, setCaptchaValue] = useState<boolean>(false);

  const querydata = useStaticQuery(graphql`
    query {
      arrowNext: file(
        sourceInstanceName: { eq: "static" }
        relativePath: { eq: "images/Arrow-Next.svg" }
      ) {
        publicURL
      }
      laptop: file(
        sourceInstanceName: { eq: "static" }
        relativePath: { eq: "images/laptop-white.svg" }
      ) {
        publicURL
      }
      mobile: file(
        sourceInstanceName: { eq: "static" }
        relativePath: { eq: "images/mobile-white.svg" }
      ) {
        publicURL
      }
      support: file(
        sourceInstanceName: { eq: "static" }
        relativePath: { eq: "images/support-white.svg" }
      ) {
        publicURL
      }
    }
  `);

  return (
    <Container id="contacts" ref={props?.reference}>
      <Wrapper>
        <Contact>
          <ContactInfo white={props.white}>
            <div className="contact-title">
              {formatMessage({ id: "contact" })}
            </div>
            <Hidden xs sm>
              <div className="contact-sub_title">
                {formatMessage({ id: "leave-us-data" })}
              </div>
              <div className="contact-sub_title">
                {formatMessage({ id: "contact-soon" })}
              </div>
            </Hidden>
            <Visible xs sm>
              <div className="contact-sub_title">
                <p>{formatMessage({ id: "contact-us" })}</p>
                <p>{formatMessage({ id: "strategic-solutions" })}</p>
              </div>
            </Visible>
          </ContactInfo>
          <ContactForm white={props.white}>
            <form
              target="_blank"
              action="https://crm.zoho.eu/crm/WebToLeadForm"
              name="WebToLeads6990000000066159"
              method="POST"
              onSubmit={e => {
                if (!captchaValue) {
                  e.preventDefault();
                  alert(`Por favor resolva a Catpcha.`);
                  return;
                }
                if (agreePolicies) {
                  alert(`Obrigado pelo seu contacto.`);
                  navigate("/");
                } else {
                  e.preventDefault();
                  alert(
                    `Para submeter o pedido de contacto é necessário confirmar que está de acordo com a nossa política de privacidade.`
                  );
                }
              }}
            >
              <input
                type="text"
                style={{ display: "none" }}
                name="xnQsjsdp"
                defaultValue="1149a5b8633fa9280ae72dc67e0c48176c999898f1c8765513cec8fa589e14ee"
              />
              <input type="hidden" name="zc_gad" id="zc_gad" />
              <input
                type="text"
                style={{ display: "none" }}
                name="xmIwtLD"
                defaultValue="5e0fa7a9a05296632fa30b05766ad217b2d19a8bb17865740666a25be05875d1"
              />
              <input
                type="text"
                style={{ display: "none" }}
                name="actionType"
                defaultValue="TGVhZHM="
              />
              <input
                type="text"
                style={{ display: "none" }}
                name="returnURL"
                defaultValue="https://www.decunify.com"
              />
              <input
                type="text"
                style={{ display: "none" }}
                name="Lead Source"
                defaultValue="Formulário Web"
              />
              {agreeNewsletter ? (
                <>
                  <input
                    type="checkbox"
                    style={{ display: "none" }}
                    name="LEADCF101"
                    defaultChecked="checked"
                  />
                </>
              ) : null}

              <label
                id="labelForDataSource"
                htmlFor="data-source"
                className="visuallyhidden"
                style={{ display: "none " }}
              />
              <input
                aria-labelledby="labelForDataSource"
                type="hidden"
                value="Decunify Contact Form"
                name="data-source"
              />
              <div className="input-fields">
                <label className="label-col" htmlFor="Last Name">
                  <div className="form-label">
                    {formatMessage({ id: "name" })}
                  </div>
                  <label
                    id="labelForName"
                    htmlFor="Last Name"
                    className="visuallyhidden"
                    style={{ display: "none " }}
                  />
                  <input
                    aria-labelledby="labelForName"
                    className="input-form"
                    type="text"
                    name="Last Name"
                    style={{ padding: "6px 10px" }}
                  />
                </label>
                <label className="label-col" htmlFor="Company">
                  <div className="form-label">
                    {formatMessage({ id: "company" })}
                  </div>
                  <label
                    id="labelForCompany"
                    htmlFor="Company"
                    className="visuallyhidden"
                    style={{ display: "none " }}
                  />
                  <input
                    aria-labelledby="labelForCompany"
                    className="input-form"
                    type="text"
                    name="Company"
                    style={{ padding: "6px 10px" }}
                  />
                </label>
              </div>
              <div className="input-fields">
                <label className="label-col" htmlFor="Mobile">
                  <div className="form-label">
                    {formatMessage({ id: "phone" })}
                  </div>
                  <label
                    id="labelForTel"
                    htmlFor="Mobile"
                    className="visuallyhidden"
                    style={{ display: "none " }}
                  />
                  <input
                    aria-labelledby="labelForTel"
                    className="input-form"
                    type="string"
                    name="Mobile"
                    style={{ padding: "6px 10px" }}
                  />
                </label>
                <label className="label-col" htmlFor="Email">
                  <div className="form-label">
                    {formatMessage({ id: "email" })}
                  </div>
                  <label
                    htmlFor="Email"
                    className="visuallyhidden"
                    style={{ display: "none " }}
                  />
                  <input
                    className="input-form"
                    type="email"
                    name="Email"
                    style={{ padding: "6px 10px" }}
                  />
                </label>
              </div>
              <div className="message-field">
                <label className="message-box" htmlFor="message">
                  <div className="form-label">
                    {formatMessage({ id: "message" })}
                  </div>
                  <textarea
                    style={{ width: "100%", padding: "6px 10px" }}
                    name="LEADCF7"
                    rows={5}
                  />
                </label>
                <div className="button_row">
                  <div className="button_col">
                    <div
                      className="newsletter"
                      style={{ marginBottom: "10px" }}
                    >
                      <Checkbox
                        white={props.white}
                        active={agreeNewsletter}
                        onChange={() => setAgreeNewsletter(!agreeNewsletter)}
                      />
                      <div>{formatMessage({ id: "wish-to-subscribe" })}</div>
                    </div>
                    <div className="privacy-group">
                      <Checkbox
                        white={props.white}
                        active={agreePolicies}
                        onChange={() => setAgreePolicies(!agreePolicies)}
                      />
                      <div>{formatMessage({ id: "read-and-understood" })}</div>
                    </div>
                    <ReCAPTCHA
                      sitekey="6LfxVOMUAAAAAK93xJVYgzuhAHsbLSHH2x1QmWPL"
                      onChange={(captcha) => setCaptchaValue(true)}
                      onExpire={() => setCaptchaValue(false) }
                      onError={() => setCaptchaValue(false)}
                    />
                  </div>
                  <div className="button_col">
                    <div className="row-submit-button">
                      <label
                        id="labelForSubject"
                        htmlFor="_subject"
                        style={{ display: "none " }}
                      />
                      <input
                        aria-labelledby="labelForSubject"
                        type="hidden"
                        name="_subject"
                        value="Message via https://decunify.com"
                        style={{ padding: "6px 10px" }}
                      />
                      <button
                        className="submit-button"
                        type="submit"
                        onClick={!captchaValue}
                      >
                        {formatMessage({ id: "send" })}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ContactForm>
          <ContactAddress>
            <Row>
              <Col xs={12} md={6} xl={4}>
                <div className="address-orange-box">
                  <div className="address-info">
                    <div className="city">Porto</div>
                    <div className="company-address">
                      <div className="address-title">
                        {formatMessage({ id: "address" })}
                      </div>
                      Rua Albino José Domingues, 509 4470-034 Maia
                    </div>
                    <div className="company-phone">
                      <div className="address-title">
                        {formatMessage({ id: "phone" })}
                      </div>
                      +351 229 439 660
                      <p className="phone-alert">
                        ({formatMessage({ id: "phoneAlertText" })})
                      </p>
                    </div>
                    <div className="company-fax">
                      <div className="address-title">
                        {formatMessage({ id: "fax" })}
                      </div>
                      +351 229 439 679
                    </div>
                    <div className="company-fax">
                      <a 
                        className="get-directions"
                        target="_blank"
                        href="https://www.google.com/maps/place/Decunify+-+Solu%C3%A7%C3%B5es+de+Comunica%C3%A7%C3%B5es,+S.A./@41.2541651,-8.6412705,17z/data=!3m1!4b1!4m5!3m4!1s0xd1ecd548dc9803d:0x187e28d38708d092!8m2!3d41.2541651!4d-8.6390818">
                        {formatMessage({ id: "directions" })}
                      </a>
                    </div>
                    <Visible xs sm>
                      <div className="directions">
                        <div className="address-title">
                          {formatMessage({ id: "directions" })}
                        </div>
                        <img
                          src={querydata.arrowNext.publicURL}
                          alt="arrow next"
                        />
                      </div>
                    </Visible>
                  </div>
                  {/* <Hidden xs sm>
                    <div className="map">
                      <GoogleMapReact
                        bootstrapURLKeys={{
                          key: "AIzaSyCSWQiwWYq5fmF9pQjBqZ3VmdUQHuHceAg"
                        }}
                        defaultCenter={{ lat: 41.254222, lng: -8.639071 }}
                        defaultZoom={12}
                      >
                        <Marker
                          lat={41.254222}
                          lng={-8.639071}
                          className="marker"
                        />
                      </GoogleMapReact>
                    </div>
                  </Hidden> */}
                </div>
              </Col>
              <Col xs={12} md={6} xl={4}>
                <div className="address-orange-box">
                  <div className="address-info">
                    <div className="city">Lisboa</div>
                    <div className="company-address">
                      <div className="address-title">
                        {formatMessage({ id: "address" })}
                      </div>
                      Rua Cesário Verde, 5 - 2º Direito Linda-a-Pastora 2790-326
                      Queijas
                    </div>
                    <div className="company-phone">
                      <div className="address-title">
                        {formatMessage({ id: "phone" })}
                      </div>
                      +351 214 489 570
                      <p className="phone-alert">
                        ({formatMessage({ id: "phoneAlertText" })})
                      </p>
                    </div>
                    <div className="company-fax">
                      <div className="address-title">
                        {formatMessage({ id: "fax" })}
                      </div>
                      +351 214 489 579
                    </div>
                    <div className="company-fax">
                      <a 
                        className="get-directions"
                        target="_blank"
                        href="https://www.google.com/maps/place/R.+Ces%C3%A1rio+Verde+5,+2790-326+Queijas/@38.7174541,-9.2570279,17z/data=!3m1!4b1!4m5!3m4!1s0xd1ecc6ce04c5e13:0xd998b45a0784a2cd!8m2!3d38.7174541!4d-9.2548392">
                        {formatMessage({ id: "directions" })}
                      </a>
                    </div>
                    <Visible xs sm>
                      <div className="directions">
                        <div className="address-title">
                          {formatMessage({ id: "directions" })}
                        </div>
                        <img
                          src={querydata.arrowNext.publicURL}
                          alt="arrow next"
                        />
                      </div>
                    </Visible>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} xl={4}>
                <div className="address-orange-box">
                  <div className="address-info">
                    <div className="city">Funchal</div>
                    <div className="company-address">
                      <div className="address-title">
                        {formatMessage({ id: "address" })}
                      </div>
                      Rua Antero Quental, 8 9000-375 Funchal
                    </div>
                    <div className="company-phone">
                      <div className="address-title">
                        {formatMessage({ id: "phone" })}
                      </div>
                      +351 291 742 333
                      <p className="phone-alert">
                        ({formatMessage({ id: "phoneAlertText" })})
                      </p>
                    </div>
                    <div className="company-fax">
                      <div className="address-title">
                        {formatMessage({ id: "fax" })}
                      </div>
                      +351 291 742 333
                    </div>
                    <div className="company-fax">
                      <a 
                        className="get-directions"
                        target="_blank"
                        href="https://goo.gl/maps/Tg4yq3kEXTZJ6A2K8">
                        {formatMessage({ id: "directions" })}
                      </a>
                    </div>
                    <Visible xs sm>
                      <div className="directions">
                        <div className="address-title">
                          {formatMessage({ id: "directions" })}
                        </div>
                        <img
                          src={querydata.arrowNext.publicURL}
                          alt="arrow next"
                        />
                      </div>
                    </Visible>
                  </div>
            
                </div>
              </Col>
            </Row>
          </ContactAddress>
          <ContactSupport white={props.white}>
            <div className="title-sup">
              {formatMessage({ id: "tech-support" })}
            </div>
            <div className="contact-row">
              <a
                className="contact-support-link"
                href="mailto:geral@decunify.com"
                alt="decunify email"
              >
                <div className="support-info">
                  <div>
                    <img
                      className="support-icon"
                      src={querydata.laptop.publicURL}
                      alt="support icon"
                    />
                  </div>
                  <div className="sub-title-support">geral@decunify.com</div>
                </div>
              </a>
              <a
                className="contact-support-link"
                href="tel:+351707201229"
                alt="decunify phone"
              >
                <div className="support-info">
                  <div>
                    <img
                      className="support-icon"
                      src={querydata.mobile.publicURL}
                      alt="support icon"
                    />
                  </div>
                  <div className="sub-title-support">+351 707 201 229(*) </div>

                </div>
              </a>
              <a
                className="contact-support-link"
                href="https://servicedesk.decunify.com/"
                alt="decunify service desk link"
              >
                <div className="support-info">
                  <div>
                    <img
                      className="support-icon"
                      src={querydata.support.publicURL}
                      alt="support icon"
                    />
                  </div>
                  <div className="sub-title-support">
                    {formatMessage({ id: "service-desk" })}
                  </div>
                </div>
              </a>
            </div>
            <div className="title-alert">
              *{formatMessage({ id: "phoneAlertTextTarif" })}
            </div>
          </ContactSupport>
        </Contact>
      </Wrapper>
    </Container>
  );
};

export default ContactSection;
